<template>
  <div />
</template>

<script>
export default {
  data() {
    return {
      test: 'foo'
    };
  }
};
</script>
